"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trimToUndefined = exports.startBeforeEndDateTimeOrEmpty = exports.startBeforeEndDateOrEmpty = exports.requiredWhen = exports.requiredStringTrimMaxWhen = exports.requiredStringTrimMax = exports.requiredString = exports.requiredSelectWhen = exports.requiredSelect = exports.requiredFileWhen = exports.requiredDigitsExactWhen = exports.requiredDateTime = exports.requiredArrayWhen = exports.requiredArrayMin = exports.requiredAlnumTrimMax = exports.optionalStringTrimMax = exports.optionalStringTrim = exports.optionalString = exports.optionalSelect = exports.optionalNumber = exports.optionalFile = exports.optionalEmail = exports.optionalDigitsMaxLength = exports.optionalBoolean = exports.numberAsStringWhenRange = exports.notFutureDateOrEmpty = exports.maxLength = exports.emailRegex = exports.dateTimeOrEmpty = exports.dateOrEmptyStrict = exports.dateOrEmpty = exports.bizNotAllowedCharsTest = exports.atLeastOneArrayAmong = exports.arrayNoIntersectionWith = exports.arrayMustIncludeWhen = void 0;
var Yup = _interopRequireWildcard(require("yup"));
var _moment = _interopRequireDefault(require("moment"));
var _labelConsts = require("../constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("../logics/stringUtil"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 *validationHelpers
 */

// 文字列の前後空白を除去し、空文字は未入力扱い（undefined）に変換
const trimToUndefined = v => {
  if (typeof v === 'string') {
    const t = v.trim();
    return t === '' ? undefined : t;
  }
  return v;
};
exports.trimToUndefined = trimToUndefined;
const emailRegex = exports.emailRegex = /^([a-zA-Z0-9])+([a-zA-Z0-9._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9._-]+)+$/;

// テキスト用：必須（前後空白を除去し、空文字は未入力扱い）
const requiredString = intl => Yup.string().transform(trimToUndefined).required(intl.formatMessage({
  id: _labelConsts.LABEL.CORE_REQUIRED_MESSAGE
}));

// テキスト用：必須＋最大文字数（maxを可変指定）
exports.requiredString = requiredString;
const requiredStringTrimMax = (intl, max) => requiredString(intl).max(max, intl.formatMessage({
  id: _labelConsts.LABEL.CORE_LENGTH_MESSAGE
}, {
  0: max
}));

// セレクト用：必須
exports.requiredStringTrimMax = requiredStringTrimMax;
const requiredSelect = intl => Yup.string().required(intl.formatMessage({
  id: _labelConsts.LABEL.CORE_PLEASE_SELECT
}));

// セレクト用：条件付き必須（depsに指定した依存値を使ってpredicateがtrueのとき必須）
exports.requiredSelect = requiredSelect;
const requiredSelectWhen = (intl, deps, predicate) => Yup.string().nullable().when(deps, {
  is: function () {
    return predicate(...arguments);
  },
  then: s => s.required(intl.formatMessage({
    id: _labelConsts.LABEL.CORE_PLEASE_SELECT
  })),
  otherwise: s => s
});

// ベーススキーマに対して条件付き必須を適用（汎用）
exports.requiredSelectWhen = requiredSelectWhen;
const requiredWhen = (intl, deps, predicate, baseSchema) => baseSchema.when(deps, {
  is: function () {
    return predicate(...arguments);
  },
  then: s => s.required(intl.formatMessage({
    id: _labelConsts.LABEL.CORE_PLEASE_SELECT
  })),
  otherwise: s => s
});

// 文字列：条件付き 必須+最大文字数（trimあり）。predicateがtrueのとき必須+max、falseならmaxのみ
exports.requiredWhen = requiredWhen;
const requiredStringTrimMaxWhen = (intl, deps, predicate, max) => Yup.string().transform(trimToUndefined) // 空文字は未入力扱いに統一
.nullable().when(deps, {
  is: function () {
    return predicate(...arguments);
  },
  then: s => s.required(intl.formatMessage({
    id: _labelConsts.LABEL.CORE_REQUIRED_MESSAGE
  })).max(max, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_LENGTH_MESSAGE
  }, {
    0: max
  })),
  otherwise: s => s.max(max, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_LENGTH_MESSAGE
  }, {
    0: max
  }))
});

// 任意（nullable）系
exports.requiredStringTrimMaxWhen = requiredStringTrimMaxWhen;
const optionalBoolean = () => Yup.boolean().nullable();
exports.optionalBoolean = optionalBoolean;
const optionalString = () => Yup.string().nullable();
exports.optionalString = optionalString;
const optionalNumber = () => Yup.number().nullable();

// セレクト任意（読みやすさのためのエイリアス）
exports.optionalNumber = optionalNumber;
const optionalSelect = () => Yup.string().nullable();

// ファイル任意（読みやすさのためのエイリアス）
exports.optionalSelect = optionalSelect;
const optionalFile = () => Yup.mixed().nullable();

// trimして空文字は未入力扱いにしたい任意文字列
exports.optionalFile = optionalFile;
const optionalStringTrim = () => Yup.string().transform(trimToUndefined).nullable();

// 文字列：最大文字数（trimなし）
exports.optionalStringTrim = optionalStringTrim;
const maxLength = (intl, max) => Yup.string().max(max, intl.formatMessage({
  id: _labelConsts.LABEL.CORE_LENGTH_MESSAGE
}, {
  0: max
}));

// 文字列：最大文字数（必須なし、trimあり）
exports.maxLength = maxLength;
const optionalStringTrimMax = (intl, max) => optionalStringTrim().max(max, intl.formatMessage({
  id: _labelConsts.LABEL.CORE_LENGTH_MESSAGE
}, {
  0: max
}));

// メール：空許容、trimして空は未入力扱い、最大長チェック、形式不正チェック
exports.optionalStringTrimMax = optionalStringTrimMax;
const optionalEmail = function (intl) {
  let {
    max = 100,
    labelId = _labelConsts.LABEL.CORE_MAIL_ADDRESS
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Yup.string().transform(trimToUndefined).nullable().max(max, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_LENGTH_MESSAGE
  }, {
    0: max
  })).test('email', intl.formatMessage({
    id: _labelConsts.LABEL.CORE_INCORRECT_MESSAGE
  }, {
    0: intl.formatMessage({
      id: labelId
    })
  }), v => !v || emailRegex.test(v));
};

// 日時用：空文字は許容、不正時はInputDateTimeが返す'invalid'を検出
exports.optionalEmail = optionalEmail;
const dateTimeOrEmpty = intl => Yup.string().test('valid-or-empty', intl.formatMessage({
  id: _labelConsts.LABEL.CORE_INVALID_DATETIME_MESSAGE
}), val => !val || val !== 'invalid');

// 日付用：空文字は許容、不正時はInputDateTimeが返す'invalid'を検出
exports.dateTimeOrEmpty = dateTimeOrEmpty;
const dateOrEmpty = intl => Yup.string().test('valid-or-empty-date', intl.formatMessage({
  id: _labelConsts.LABEL.CORE_INVALID_DATE_MESSAGE
}), val => !val || val !== 'invalid');

// 日時用：開始日時が終了日時よりも新しい日時の場合はエラー
exports.dateOrEmpty = dateOrEmpty;
const startBeforeEndDateTimeOrEmpty = (intl, startFieldName, endFieldName) => Yup.string().test('start-before-end-datetime', intl.formatMessage({
  id: _labelConsts.LABEL.CORE_SRH_START_DT_CHECK_MSG
}), function (v) {
  var _this$parent;
  const end = (_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent[endFieldName];
  if (!v || v === 'invalid' || !end || end === 'invalid') return true;
  return v <= end;
});

// 日付用：開始日が終了日よりも新しい日付の場合はエラー
exports.startBeforeEndDateTimeOrEmpty = startBeforeEndDateTimeOrEmpty;
const startBeforeEndDateOrEmpty = (intl, startFieldName, endFieldName) => Yup.string().test('start-before-end-date', intl.formatMessage({
  id: _labelConsts.LABEL.CORE_SRH_START_DT_CHECK_MSG
}), function (v) {
  var _this$parent2;
  const end = (_this$parent2 = this.parent) === null || _this$parent2 === void 0 ? void 0 : _this$parent2[endFieldName];
  if (!v || v === 'invalid' || !end || end === 'invalid') return true;
  return v <= end;
});

// 英数字コード：必須（trim）＋最大長＋英数字のみ
exports.startBeforeEndDateOrEmpty = startBeforeEndDateOrEmpty;
const requiredAlnumTrimMax = function (intl, max) {
  let {
    labelId
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return Yup.string().transform(trimToUndefined).required(intl.formatMessage({
    id: _labelConsts.LABEL.CORE_REQUIRED_MESSAGE
  })).max(max, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_LENGTH_MESSAGE
  }, {
    0: max
  })).test('alnum', intl.formatMessage({
    id: _labelConsts.LABEL.CORE_CONTAINS_NON_ALPHANUMERIC_MESSAGE
  }, {
    0: labelId ? intl.formatMessage({
      id: labelId
    }) : ''
  }), v => !v || /^[0-9A-Za-z]+$/.test(v));
};

// 日付用：厳密な形式チェック（YYYY/MM/DD）＋'invalid'検出。未入力は許容
exports.requiredAlnumTrimMax = requiredAlnumTrimMax;
const dateOrEmptyStrict = intl => Yup.string().test('valid-or-empty-date-strict', intl.formatMessage({
  id: _labelConsts.LABEL.CORE_INVALID_DATE_MESSAGE
}), val => {
  if (!val) return true; // 未入力は許容
  return val !== 'invalid' && (0, _moment.default)(val, 'YYYY/MM/DD', true).isValid();
});

// 日付用：未来日不可。未入力や'invalid'はこの検証ではスキップ
exports.dateOrEmptyStrict = dateOrEmptyStrict;
const notFutureDateOrEmpty = intl => Yup.string().test('not-future-date', intl.formatMessage({
  id: _labelConsts.LABEL.KANSA_UNABLE_ENTER_FUTURE_DATE
}), val => {
  if (!val || val === 'invalid') return true;
  const m = (0, _moment.default)(val, 'YYYY/MM/DD', true);
  if (!m.isValid()) return true;
  return !m.isAfter((0, _moment.default)(), 'day');
});

/**
 * 数値（文字列入力）系：条件付き必須＋形式（小数桁）＋範囲
 * - 文字列入力を前提に、trimして空は未入力扱い
 * - deps/predicate が true のとき required、false のとき任意
 * - decimalPlaces が 0 の場合は整数のみ、>0 の場合は小数点以下ちょうど decimalPlaces 桁を許容
 * - 範囲は min〜max（どちらも含む）
 */
exports.notFutureDateOrEmpty = notFutureDateOrEmpty;
const numberAsStringWhenRange = (intl, deps, predicate, _ref) => {
  let {
    min,
    max,
    decimalPlaces = 0
  } = _ref;
  return Yup.string().transform(trimToUndefined).nullable().when(deps, {
    is: function () {
      return predicate(...arguments);
    },
    then: s => s.required(intl.formatMessage({
      id: _labelConsts.LABEL.CORE_REQUIRED_MESSAGE
    })),
    otherwise: s => s
  }).test('format', intl.formatMessage({
    id: _labelConsts.LABEL.CORE_INCORRECT_RANGE_MESSAGE
  }, {
    0: min,
    1: max
  }), v => {
    if (!v) return true;
    const dp = Math.max(0, decimalPlaces);
    const re = dp === 0 ? /^([1-9]\d*)$/ : new RegExp("^([1-9]\\d*)(\\.\\d{".concat(dp, "})?$"));
    return re.test(v);
  }).test('range', intl.formatMessage({
    id: _labelConsts.LABEL.CORE_INCORRECT_RANGE_MESSAGE
  }, {
    0: min,
    1: max
  }), v => {
    if (!v) return true;
    const num = parseFloat(v);
    if (Number.isNaN(num)) return false;
    return num >= min && num <= max;
  });
};

/**
 * ファイル（Yup.mixed）系：条件付き必須
 * - deps/predicate が true のとき required、false のとき任意
 */
exports.numberAsStringWhenRange = numberAsStringWhenRange;
const requiredFileWhen = (intl, deps, predicate) => Yup.mixed().nullable().when(deps, {
  is: function () {
    return predicate(...arguments);
  },
  then: s => s.required(intl.formatMessage({
    id: _labelConsts.LABEL.CORE_PLEASE_SELECT
  })),
  otherwise: s => s
});

/* 追加ヘルパー（共通化提案の反映） */

// 日時用：必須＋InputDateTime 'invalid' 検出
exports.requiredFileWhen = requiredFileWhen;
const requiredDateTime = intl => Yup.string().required(intl.formatMessage({
  id: _labelConsts.LABEL.CORE_PLEASE_SELECT
})).test('valid-datetime', intl.formatMessage({
  id: _labelConsts.LABEL.CORE_INVALID_DATETIME_MESSAGE
}), v => !!v && v !== 'invalid');

// 配列：必須（min個以上）
exports.requiredDateTime = requiredDateTime;
const requiredArrayMin = function (intl) {
  let min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return Yup.array().of(Yup.string()).min(min, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_PLEASE_SELECT
  }));
};

// 配列：条件付き必須（min個以上）
exports.requiredArrayMin = requiredArrayMin;
const requiredArrayWhen = function (intl, deps, predicate) {
  let {
    min = 1
  } = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return Yup.array().of(Yup.string()).when(deps, {
    is: function () {
      return predicate(...arguments);
    },
    then: s => s.min(min, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_PLEASE_SELECT
    })),
    otherwise: s => s
  });
};

// 配列：条件付きで特定要素（requiredElement）を含むこと
exports.requiredArrayWhen = requiredArrayWhen;
const arrayMustIncludeWhen = function (intl, deps, predicate, requiredElement) {
  let {
    messageId = _labelConsts.LABEL.MASTERDATA_MY_BU_CHECK_MESSAGE
  } = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return Yup.array().of(Yup.string()).when(deps, {
    is: function () {
      return predicate(...arguments);
    },
    then: s => s.test('include-required', intl.formatMessage({
      id: messageId
    }), v => Array.isArray(v) && v.includes(requiredElement)),
    otherwise: s => s
  });
};

// 配列：他配列との重複（共通要素）禁止
exports.arrayMustIncludeWhen = arrayMustIncludeWhen;
const arrayNoIntersectionWith = function (intl, otherFieldName) {
  let {
    messageId = _labelConsts.LABEL.MASTERDATA_DISASTER_TDFK_DUPLICATE_MESSAGE
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return Yup.array().of(Yup.string()).test('no-intersection', intl.formatMessage({
    id: messageId
  }), function (v) {
    var _this$parent3;
    if (!Array.isArray(v)) return true;
    const other = (_this$parent3 = this.parent) === null || _this$parent3 === void 0 ? void 0 : _this$parent3[otherFieldName];
    if (!Array.isArray(other)) return true;
    const set = new Set(other);
    return !v.some(x => set.has(x));
  });
};

// 配列：複数配列のうち少なくとも1つに要素があること（.test に渡せるタプルを返す）
exports.arrayNoIntersectionWith = arrayNoIntersectionWith;
const atLeastOneArrayAmong = (intl, fieldNames) => ['at-least-one-among', intl.formatMessage({
  id: _labelConsts.LABEL.CORE_PLEASE_SELECT
}), function () {
  const parent = this.parent || {};
  return fieldNames.some(k => Array.isArray(parent[k]) && parent[k].length > 0);
}];

// 数値（文字列）：任意＋半角数字のみ＋最大桁数（allowZero=false の場合は0不可）
exports.atLeastOneArrayAmong = atLeastOneArrayAmong;
const optionalDigitsMaxLength = function (intl, maxDigits) {
  let {
    allowZero = true
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return Yup.string().nullable().max(maxDigits, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_LENGTH_MESSAGE
  }, {
    0: maxDigits
  })).test('digits', intl.formatMessage({
    id: _labelConsts.LABEL.CORE_ENTER_HALF_NUMERIC
  }), v => {
    if (!v) return true;
    if (!/^[0-9]+$/.test(v)) return false;
    if (!allowZero) return Number(v) > 0;
    return true;
  });
};

// 未許可文字チェック（文字列）：含まれる場合は検出文字をメッセージに差し込んでエラー
exports.optionalDigitsMaxLength = optionalDigitsMaxLength;
const bizNotAllowedCharsTest = function (intl, bizNotAllowedChars) {
  let {
    joiner = ' '
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return ['biz-not-allowed', '', function (v) {
    if (!v) return true;
    const chars = _stringUtil.default.getIncludesCharacters(v, bizNotAllowedChars, true);
    if (Array.isArray(chars) && chars.length > 0) {
      return this.createError({
        message: intl.formatMessage({
          id: _labelConsts.LABEL.CORE_NOT_ALLOWED_CHARACTER
        }, {
          0: chars.join(joiner)
        })
      });
    }
    return true;
  }];
};

// 数値（文字列）：条件付きで「必須＋ちょうど digits 桁の半角数字」
exports.bizNotAllowedCharsTest = bizNotAllowedCharsTest;
const requiredDigitsExactWhen = function (intl, deps, predicate, digits) {
  let {
    patternMessageId = _labelConsts.LABEL.CORE_DOCUMENT_EDITION_NUMBER_MESSAGE
  } = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return Yup.string().transform(trimToUndefined).nullable().when(deps, {
    is: function () {
      return predicate(...arguments);
    },
    then: s => s.required(intl.formatMessage({
      id: _labelConsts.LABEL.CORE_REQUIRED_MESSAGE
    })).test('digits-exact', intl.formatMessage({
      id: patternMessageId
    }), v => !!v && new RegExp("^\\d{".concat(digits, "}$")).test(v)),
    otherwise: s => s
  });
};
exports.requiredDigitsExactWhen = requiredDigitsExactWhen;